<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $tc("user", 1) }}
      </div>
      <router-link class="btn-blue" to="users"
        >{{ $tc("user", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>

    <b-modal
      id="editPassword"
      title="Change Pin"
      size="lg"
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
    >
      <button
        @click.prevent.stop="OnCloseModal"
        class="btn-modal-close"
        style="position: absolute; right: 15px; top: 15px; z-index: 99"
      >
        &times;
      </button>
      <div class="row mb-2 mx-0">
        <div class="col-12">
          <div class="text-center mb-4 pb-2 mt-3">
            <h4>Create Password PIN</h4>
          </div>
          <!-- Current / Existing Password -->
          <!-- <form data-vv-scope="form1"> -->
          <div
            class="col-lg-10 mx-auto align-self-center"
            v-if="showcurrentpassword"
          >
            <div class>
              <div class="mb-3">
                <div class="input-material">
                  <input
                    type="password"
                    v-model="password"
                    name="currentpass"
                    id="currentpass"
                    v-validate="'required'"
                    placeholder="."
                    v-on:keyup.enter="ProceedtoNewPassword"
                  />
                  <label>Current Logged In User's Password</label>
                </div>
                <p class="error_message">
                  <span v-if="submitted1 && errors.has('form1.currentpass')">{{
                    errors.first("form1.currentpass")
                  }}</span>
                </p>
              </div>
              <div class="d-flex">
                <button
                  @click="$bvModal.hide('editPassword')"
                  class="btn-white-lg w-50 mr-2"
                >
                  Cancel
                </button>
                <button
                  @click.prevent.stop="ProceedtoNewPassword"
                  class="btn-blue-lg w-50 ml-2"
                >
                  Proceed
                </button>
              </div>
            </div>
          </div>
          <!-- </form> -->
          <!-- New Password -->
          <!-- <form data-vv-scope="form2"> -->
          <div class="col-lg-10 pl-5 align-self-center" v-if="shownewpassword">
            <div>
              <div class="mb-3">
                <div class="input-material">
                  <input
                    type="password"
                    v-model="passwordpin"
                    name="passwordpin"
                    id="passwordpin"
                    ref="passwordpin"
                    v-validate="'required|numeric|min:4|max:8'"
                    placeholder="."
                    autofocus
                  />
                  <label>Enter New Password</label>
                </div>
                <p class="error_msg">
                  <span
                    v-if="submitted2 && errors.has('form2.passwordpin')"
                    class="error_message"
                    >{{ errors.first("form2.passwordpin") }}</span
                  >
                </p>
              </div>
              <div class="mb-3">
                <div class="input-material">
                  <input
                    type="password"
                    v-model="cpassword"
                    name="confirm_password"
                    id="confirm_password"
                    v-validate="'required|confirmed:passwordpin'"
                    placeholder="."
                    autofocus
                    v-on:keyup.enter="onFinalProceed"
                  />
                  <label>Confirm Password</label>
                </div>
                <p class="error_message">
                  <span
                    v-if="submitted2 && errors.has('form2.confirm_password')"
                    class="error_message"
                    >{{ errors.first("form2.confirm_password") }}</span
                  >
                </p>
              </div>
              <div class="d-flex">
                <button
                  @click.prevent.stop="$bvModal.hide('editPassword')"
                  class="btn-white-lg w-50 mr-2"
                >
                  Cancel
                </button>
                <button
                  @click.prevent.stop="onFinalProceed"
                  class="btn-blue-lg w-50 ml-2"
                >
                  Proceed
                </button>
              </div>
            </div>
          </div>
          <!-- </form> -->
        </div>
      </div>
    </b-modal>

    <div class="white-wrapper my-3">
      <form class="row">
        <!-- Personal Details -->
        <section v-if="true" class="mb-4 w-100 px-3 section-new">
          <div
            class="section-title mb-3 d-flex justify-content-between section-collapse-box new-border"
            style="padding: 6px; align-items: center; border-radius: 10px"
            v-b-toggle.personalDetailsForm
          >
            <span class="fs">
              {{ $tc("Personal Details", 2) }}
            </span>
            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>
          <b-collapse
            id="personalDetailsForm"
            class="mt-2"
            v-model="sectionCollapse.personalDetailsForm"
          >
            <div
              class="row pr-2 pl-2 pt-3 new-border pb-2 br-10 mx-auto back"
              style="border-radius: 10px"
            >
              <div class="col-lg-6 col-xl-3 align-self-center mb-2">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      type="text"
                      v-model="userDetails.first_name"
                      name="firstname"
                      id="firstname"
                      v-validate="'required|alpha_spaces'"
                    />
                    <label>{{ $t("name") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_NameTooltip')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('firstname')">{{
                    errors.first("firstname")
                  }}</span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-3 align-self-center mb-2">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      type="text"
                      v-model="userDetails.middle_name"
                      v-validate="{ regex: /^[a-zA-Z- ]*$/ }"
                      name="middlename"
                      id="middlename"
                    />
                    <label>{{ $t("middlename") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_MiddleName')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('middlename')">{{
                    errors.first("middlename")
                  }}</span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-3 align-self-center mb-2">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="userDetails.last_name"
                      type="text"
                      name="lastname"
                      id="lastname"
                      v-validate="'required|alpha_spaces'"
                    />
                    <label>{{ $t("lastname") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_LastName')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('lastname')">{{
                    errors.first("lastname")
                  }}</span>
                </p>
              </div>
              <!-- , flag.isDistributor ? 'd-none' : ''] -->
              <div
                :class="[
                  'col-lg-6 col-xl-3 align-self-center mb-4 mt-2 ',
                  flag.isDistributor ? 'd-none' : '',
                ]"
              >
                <!-- <div v-if="!flag.isDistributor" class="col-lg-6 col-xl-3 align-self-center mb-3"> -->
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="userDetails.up_employee_code"
                      type="text"
                      name="employeeid"
                      id="employeeid"
                      v-validate="flag.isDistributor ? '' : ''"
                    />
                    <label>{{ $t("employeeid") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_Employee')" /> -->
                </div>
                <!-- <p class="error_message">
            <span v-if="submitted && errors.has('employeeid')">{{
              errors.first("employeeid")
            }}</span>
          </p> -->
              </div>

              <div
                :class="[
                  'col-lg-6 col-xl-3 align-self-center mb-3 mt-2 ',
                  flag.isDistributor ? 'd-none' : '',
                ]"
              >
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label
                      :class="
                        selected.Gender && selected.Gender.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $tc("gender", 1) }}</label
                    >
                    <b-dropdown
                      :text="selected.Gender"
                      variant="dropdown-curve"
                      class="w-100"
                    >
                      <b-dropdown-item
                        v-for="(gender, genderIndex) in Gender"
                        :key="genderIndex"
                        v-on:click="onSelectHandler('gender', gender)"
                        name="selectgender"
                        id="selectgender"
                        >{{ gender.gender }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                  <!-- <Tooltip :title="$t('user_Gender')" /> -->
                </div>
                <!-- <p class="error_message">
            <span v-if="submitted && selected.Gender == ''">{{
              $t("selectgender")
            }}</span>
          </p> -->
              </div>
              <div
                :class="[
                  'col-lg-6 col-xl-3 align-self-center mb-3 mt-2 ',
                  flag.isDistributor ? 'd-none' : '',
                ]"
              >
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label
                      :class="
                        userDetails.up_employment_type &&
                        userDetails.up_employment_type.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $t("employeetype") }}</label
                    >
                    <b-dropdown
                      :text="userDetails.up_employment_type"
                      variant="dropdown-curve"
                      class="btn-drop w-100"
                    >
                      <b-dropdown-item
                        v-for="(value, typeIndex) in employeementType"
                        :key="typeIndex"
                        v-on:click="onSelectEmployeementTypeHandler(value)"
                        >{{ value }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                  <!-- <Tooltip :title="$t('user_EmployementType')" /> -->
                </div>
                <!-- <p class="error_message">
            <span v-if="submitted && userDetails.up_employment_type == ''">{{
              $t("selectemptype")
            }}</span>
          </p> -->
              </div>

              <div
                :class="[
                  'col-lg-6 col-xl-3 align-self-center mb-1 mt-2 ',
                  flag.isDistributor ? 'd-none' : '',
                ]"
              >
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <div class="add-datepicker">
                      <button
                        class="btn-clearDate"
                        v-if="userDetails.up_dob"
                        v-on:click="clearSelectedDate()"
                      >
                        ✖
                      </button>
                      <Datepicker
                        :monday-first="true"
                        ref="programaticOpen"
                        v-model="userDetails.up_dob"
                        name="dob"
                        id="dob"
                        :typeable="true"
                        :disabledDates="{
                          from: new Date(2010, 11, 31),
                        }"
                      ></Datepicker>
                      <label
                        :class="
                          typeof userDetails.up_dob === 'object' ? 'active' : ''
                        "
                        >{{ $t("dob") }}</label
                      >
                    </div>
                  </div>
                  <!-- <Tooltip :title="$t('user_DateOfBirth')" /> -->
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>
              <!-- {{flag.isDistributor}} -->
              <div
                :class="[
                  'col-lg-6 col-xl-3 align-self-center mb-1 mt-2',
                  flag.isDistributor ? 'd-none' : '',
                ]"
              >
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <div class="add-datepicker">
                      <button
                        class="btn-clearDate"
                        v-if="userDetails.up_doj"
                        v-on:click.prevent.stop="cleardoj()"
                      >
                        ✖
                      </button>
                      <Datepicker
                        :monday-first="true"
                        ref="programaticOpen"
                        v-model="userDetails.up_doj"
                        name="doj"
                        id="doj"
                        :typeable="true"
                        :disabledDates="{
                          to: previousdate,
                          from: futuredate,
                        }"
                      ></Datepicker>
                      <label
                        :class="
                          typeof userDetails.up_doj === 'object' ? 'active' : ''
                        "
                        >{{ $t("doj") }}</label
                      >
                    </div>
                  </div>
                  <!-- <Tooltip :title="$t('user_DateOfJoining')" /> -->
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-3 align-self-center mb-3 mt-2">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="userDetails.up_address1"
                      type="text"
                      name="address"
                      id="address"
                      v-validate=""
                    />
                    <!-- v-validate="'required|regex: /^[_]*$/|alpha_dash|alpha_num|alpha_spaces'" -->
                    <label>{{ $t("address") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_Address')" /> -->
                </div>
                <!-- <p class="error_message">
            <span v-if="submitted && errors.has('address')">{{
              errors.first("address")
            }}</span>
          </p> -->
              </div>

              <div class="col-lg-6 col-xl-3 align-self-center mb-1 mt-2">
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label
                      :class="
                        selected.Country && selected.Country.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $tc("country", 1) }}</label
                    >
                    <b-dropdown
                      :text="selected.Country"
                      variant="dropdown-curve"
                      class="btn-drop w-100"
                    >
                      <div class="px-2 pb-2">
                        <input
                          required
                          autofocus
                          type="search"
                          placeholder="Search Country"
                          class="form-control form-control-sm"
                          v-on:keyup="onSearchCountry($event.target.value)"
                          v-on:keydown="onSearchCountry($event.target.value)"
                          v-on:search="onSearchCountry($event.target.value)"
                          v-model="searchCountry"
                        />
                      </div>
                      <b-dropdown-item
                        v-for="(country, countryIndex) in Countries"
                        :key="countryIndex"
                        v-on:click="onSelectHandler('country', country)"
                        name="selectcountry"
                        id="selectcountry"
                        >{{ country.country_name }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                  <!-- <Tooltip :title="$t('user_Country')" /> -->
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-3 align-self-center mb-1 mt-2">
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label
                      :class="
                        selected.State && selected.State.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $tc("state", 1) }}</label
                    >
                    <b-dropdown
                      :text="selected.State"
                      variant="dropdown-curve"
                      class="btn-drop w-100"
                    >
                      <div class="px-2 pb-2">
                        <input
                          required
                          autofocus
                          type="search"
                          placeholder="Search State"
                          class="form-control form-control-sm"
                          v-on:keyup="onSearchState($event.target.value)"
                          v-on:keydown="onSearchState($event.target.value)"
                          v-on:search="onSearchState($event.target.value)"
                          v-model="searchState"
                        />
                      </div>
                      <b-dropdown-item
                        v-for="(state, stateIndex) in States"
                        :key="stateIndex"
                        @click="onSelectHandler('state', state)"
                        name="selectstate"
                        id="selectstate"
                        >{{ state.state_name }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                  <!-- <Tooltip :title="$t('user_State')" /> -->
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-3 align-self-center mb-3 mt-2">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="userDetails.city_name"
                      type="text"
                      name="city_name"
                      id="city_name"
                    />
                    <label>{{ $tc("city", 1) }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_Cities')" /> -->
                </div>
              </div>

              <div class="col-lg-6 col-xl-3 align-self-center mb-3 mt-2">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="userDetails.zipcode"
                      type="text"
                      name="zipcode"
                      id="zipcode"
                      v-validate="'alpha_num'"
                    />
                    <label>{{ $t("zipcode") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_ZipCode')" /> -->
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-3 align-self-center mb-3 mt-2">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="userDetails.email_id"
                      type="email"
                      name="email_id"
                      id="email_id"
                      v-validate="'required|email'"
                    />
                    <!-- bcoz  v-validate="'required|email'" -->
                    <label>{{ $t("emailid") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_EmailId')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('email_id')">{{
                    errors.first("email_id")
                  }}</span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-3 align-self-center mb-3 mt-2">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="userDetails.up_alt_contact_no"
                      type="text"
                      name="phoneno"
                      id="phoneno"
                      v-validate="'numeric|min:7'"
                    />
                    <label>{{ $t("phone") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_phone')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('phoneno')">{{
                    errors.first("phoneno")
                  }}</span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-3 align-self-center mb-3 mt-2">
                <div class="d-flex align-items-center">
                  <div class="input-material row">
                    <div class="col-4">
                      <b-dropdown
                        :text="
                          userDetails.country_mob_code
                            ? userDetails.country_mob_code
                            : 'Code'
                        "
                        variant="dropdown-curve"
                        class="w-100 text-center mr-3"
                        placeholder="code"
                        name="countrycode"
                        id="countrycode"
                      >
                        <div class="px-2 pb-2">
                          <input
                            required
                            autofocus
                            type="search"
                            placeholder="Search Code"
                            class="form-control form-control-sm"
                            v-on:keyup="onSearchCode($event.target.value)"
                            v-on:keydown="onSearchCode($event.target.value)"
                            v-on:search="onSearchCode($event.target.value)"
                            v-model="searchCode"
                          />
                        </div>
                        <b-dropdown-item
                          href="#"
                          v-for="(countrycode, countryIndex) in countryList"
                          :key="countryIndex"
                          v-on:click="
                            onSelectHandler('countrycode', countrycode)
                          "
                          v-if="countrycode.country_mob_code != null"
                          >{{ countrycode.country_mob_code }}</b-dropdown-item
                        >
                      </b-dropdown>
                    </div>
                    <div class="col-8 pl-1">
                      <input
                        placeholder="."
                        v-model="userDetails.mobile_no"
                        type="text"
                        name="mobileno"
                        id="monileno"
                        v-validate="'required|numeric|min:8|max:14'"
                        style="width: 180.45px"
                      />
                      <label>{{ $t("mobiles") }}</label>
                    </div>
                  </div>
                  <!-- <Tooltip :title="$t('user_mobile')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && !userDetails.country_mob_code">{{
                    "Country Code Required."
                  }}</span>
                  <span>{{ " " }}</span>
                  <span v-if="submitted && errors.has('mobileno')">{{
                    errors.first("mobileno")
                  }}</span>
                </p>
              </div>
            </div>
          </b-collapse>
        </section>
        <!-- End pesonal details -->
        <!-- userpin -->
        <section v-if="true" class="mb-4 w-100 px-3 section-new">
          <div
            class="section-title mb-3 d-flex justify-content-between section-collapse-box new-border"
            style="padding: 6px; align-items: center; border-radius: 10px"
            v-b-toggle.loginDetails
          >
            <span class="fs">
              {{ $tc("Login Details", 2) }}
            </span>
            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>
          <b-collapse
            id="loginDetails"
            class="mt-2"
            v-model="sectionCollapse.loginDetails"
          >
            <div
              class="row pr-2 pl-2 pt-3 pb-2 new-border br-10 mx-auto back"
              style="border-radius: 10px"
            >
              <div class="col-lg-6 col-xl-3 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <!-- required -->
                    <input
                      placeholder="."
                      v-model="userDetails.userpin"
                      v-validate="'required|numeric|min:4|max:8'"
                      type="text"
                      name="userpin"
                      id="userpin"
                    />
                    <label>{{ $t("userpin") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('userpin')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('userpin')">{{
                    errors.first("userpin")
                  }}</span>
                </p>
              </div>
              <!-- <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="userDetails.username"
                type="text"
                name="username"
                id="username"
              />
              <label>{{ $t('username') }}</label>
            </div>
            <Tooltip :title="$t('user_Username')" />
          </div>
          <p
            v-if="submitted && errors.has('username')"
            class="error_message"
          >{{ errors.first('username') }}</p>
        </div>-->

              <!-- <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="userDetails.password"
                type="password"
                name="password"
                id="password"
              />
              <label>{{ $t('password') }}</label>
            </div>
            <Tooltip :title="$t('user_Password')" />
          </div>
          <p v-if="submitted" class="error_message">{{errmsg}}</p>
        </div>-->
              <!-- v-validate="{required: 'required', regex:/^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,16}$/}" -->
              <div
                v-if="this.loginRoleId !== 3"
                class="col-lg-6 col-xl-3 align-self-center mb-3"
              >
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label
                      :class="
                        selected.Role && selected.Role.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $tc("role", 1) }}</label
                    >
                    <b-dropdown
                      :text="selected.Role"
                      variant="dropdown-curve"
                      class="w-100"
                    >
                      <div class="px-2 pb-2">
                        <input
                          required
                          autofocus
                          type="search"
                          placeholder="Search Roles"
                          class="form-control form-control-sm"
                          v-on:keyup="onSearchRoles()"
                          v-on:keydown="onSearchRoles()"
                          v-on:search="onSearchRoles()"
                          v-model="searchRole"
                        />
                      </div>
                      <b-dropdown-item
                        v-for="(role, roleIndex) in Roles"
                        :key="roleIndex"
                        @click="onSelectHandler('role', role)"
                        name="selectrole"
                        id="selectrole"
                        >{{ role.role_name }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                  <!-- <Tooltip :title="$t('user_Roles')" /> -->
                </div>
                <p class="error_message">
                  <span
                    v-if="
                      submitted && selected.Role && selected.Role.length == 0
                    "
                    >{{ $t("select_user_Roles") }}</span
                  >
                </p>
              </div>

              <div
                class="col-lg-6 col-xl-3 align-self-center mb-3"
                v-if="[4, 8].includes(userDetails.role_id)"
              >
                <div class="d-flex align-items-center" style="gap: 20px">
                  <div class="d-flex align-items-center">
                    <b-form-checkbox
                      v-model="userDetails.pos_access"
                      unchecked-value="N"
                      value="Y"
                      name="check-button"
                      class="j-checkbox mb-0"
                    />
                    <label class="mb-0">POS Access</label>
                  </div>
                  <div class="d-flex align-items-center">
                    <b-form-checkbox
                      v-model="userDetails.fnb_access"
                      unchecked-value="N"
                      value="Y"
                      name="check-button"
                      class="j-checkbox mb-0"
                    />
                    <label class="mb-0">FNB Access</label>
                  </div>
                </div>
                <p class="error_message"></p>
              </div>
              <div
                class="col-lg-6 col-xl-3 align-self-center mb-3"
                v-if="[13].includes(userDetails.role_id)"
              >
                <div class="d-flex align-items-center" style="font-size: 13px">
                  <b-form-radio
                    :value="'N'"
                    class="j-radio"
                    v-model="userDetails.order_pickup_access_only"
                  >
                    <div>
                      <span>{{ "Kitchen Staff" }}</span>
                    </div>
                  </b-form-radio>
                  <strong class="mx-3">OR</strong>

                  <b-form-radio
                    :value="'Y'"
                    class="j-radio"
                    v-model="userDetails.order_pickup_access_only"
                  >
                    <div>
                      <span>{{ "Delivery Staff" }}</span>
                    </div>
                  </b-form-radio>
                </div>
                <p class="error_message"></p>
              </div>

              <div
                :class="[
                  'col-lg-6 col-xl-3 align-self-center mb-3',
                  flag.isDistributor ? 'd-none' : '',
                ]"
              >
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label
                      :class="
                        selected.Designation && selected.Designation.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $tc("designation", 1) }}</label
                    >
                    <b-dropdown
                      :text="selected.Designation"
                      variant="dropdown-curve"
                      class="w-100"
                    >
                      <b-dropdown-item
                        v-for="(designation, designationIndex) in Designations"
                        :key="designationIndex"
                        @click="onSelectHandler('designation', designation)"
                        name="selectdesignation"
                        id="selectdesignation"
                        >{{ designation.designation }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                  <!-- <Tooltip :title="$t('user_Designation')" /> -->
                </div>
                <p class="error_message">
                  <span
                    v-if="
                      submitted &&
                      selected.Designation &&
                      selected.Designation.length == 0
                    "
                    >{{ this.messagedesignation }}</span
                  >
                </p>
              </div>
              <div
                v-if="this.loginRoleId == 1 || this.loginRoleId == 2"
                :class="[
                  'col-lg-6 col-xl-3 align-self-center mb-3 ',
                  flag.isDistributor ? 'd-none' : '',
                ]"
              >
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label
                      :class="
                        selected.Cinemas && selected.Cinemas.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $tc("cinema", 1) }}</label
                    >
                    <b-dropdown
                      :disabled="isRoleID"
                      :text="selected.Cinemas"
                      variant="dropdown-curve"
                      class="w-100"
                    >
                      <div class="px-2 pb-2">
                        <input
                          required
                          autofocus
                          type="search"
                          placeholder="Search Cinema"
                          class="form-control form-control-sm"
                          v-on:keyup="onSearchCinema()"
                          v-on:keydown="onSearchCinema()"
                          v-on:search="onSearchCinema()"
                          v-model="searchCinema"
                        />
                      </div>
                      <b-dropdown-item
                        @click="selectAllCinemas"
                        name="selectAllCinemas"
                        id="selectAllCinemas"
                        >All</b-dropdown-item
                      >
                      <b-dropdown-item
                        v-for="(cinema, cinemaIndex) in activeCinemas"
                        :key="cinemaIndex"
                        @click="onSelectHandler('cinema', cinema)"
                        name="selectcinema"
                        id="selectcinema"
                        >{{ cinema.cine_name }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                  <!-- <Tooltip :title="$t('user_Cinema')" /> -->
                </div>
                <p class="error_message">
                  <span
                    v-if="
                      submitted &&
                      userDetails.cinema_id == '' &&
                      (userDetails.role_id == 3 ||
                        userDetails.role_id == 4 ||
                        userDetails.role_id == 7 ||
                        userDetails.role_id == 8)
                    "
                    >{{ messagecinema }}</span
                  >
                </p>
              </div>

              <div
                class="col-lg-6 col-xl-3 align-self-center mb-3"
                v-if="[4, 8].includes(userDetails.role_id)"
              >
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label :class="userDetails['store_id'] ? 'shift-up' : ''">{{
                      "Store Management"
                    }}</label>
                    <multiselect
                      :options="storeList"
                      v-model="userDetails['selectedStore']"
                      :searchable="true"
                      label="sm_store_name"
                      track-by="sm_id"
                      placeholder=""
                      @select="onSelectHandler('store', $event)"
                      @remove="removeHandler('store', $event)"
                      v-b-tooltip.hover
                      :title="'Select Store'"
                    ></multiselect>
                  </div>
                  <!-- <Tooltip :title="$t('user_Country')" /> -->
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <!-- Department -->
              <div
                class="col-lg-6 col-xl-3 align-self-center mb-3"
                v-if="flag.isDistributor === false"
              >
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label
                      :class="
                        selected.Departments && selected.Departments.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $t("department") }}</label
                    >
                    <b-dropdown
                      :text="selected.Departments"
                      variant="dropdown-curve"
                      class="w-100"
                    >
                      <b-dropdown-item
                        v-for="(department, departmentIndex) in Departments"
                        :key="departmentIndex"
                        @click="onSelectHandler('department', department)"
                        name="selectdepartment"
                        id="selectdepartment"
                        >{{ department.dept_name }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                  <!-- <Tooltip :title="$t('user_Department')" /> -->
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <!-- Distributor -->
              <div
                v-if="flag.isDistributor"
                class="col-lg-6 col-xl-3 align-self-center mb-3"
              >
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label
                      :class="
                        selected.Distributor && selected.Distributor.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >Select Distributor</label
                    >
                    <b-dropdown
                      :text="selected.Distributor"
                      variant="dropdown-curve"
                      class="w-100"
                    >
                      <b-dropdown-item
                        v-for="(distributor, distributorIndex) in Distributors"
                        :key="distributorIndex"
                        @click="onSelectHandler('distributor', distributor)"
                        name="selectdistributor"
                        id="selectditributor"
                        >{{ distributor.d_company_name }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                  <!-- <Tooltip :title="$t('user_Distributor')" /> -->
                </div>
                <p class="error_message">
                  <span
                    v-if="
                      submitted &&
                      selected.Distributor &&
                      selected.Distributor.length == 0
                    "
                    >{{ this.messagedistributor }}</span
                  >
                </p>
              </div>

              <div class="col-lg-6 col-xl-3 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <label for="file-selector" class="file-selector w-100">
                    <label class="file-selector-label shift-up">{{
                      $t("uploaduserimage")
                    }}</label>
                    <span>{{ userDetails.user_profile_image_url }}</span>
                    <input
                      v-on:change="uploadImage($event)"
                      type="file"
                      class="d-none"
                      id="file-selector"
                    />
                  </label>

                  <!-- <Tooltip
                    :title="`Logo should be of dimension 300x300 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg`"
                  /> -->
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>
              <!-- {{this.affectedUserId}}
        {{this.editorUser}}-->

              <div class="col-lg-6 col-xl-3 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label :class="selectedUserLocations ? 'shift-up' : ''"
                      >{{ "Other Locations" }}}</label
                    >
                    <multiselect
                      :options="USERSLOCATIONS"
                      v-model="selectedUserLocations"
                      :searchable="true"
                      :customLabel="setUserLocationLabel"
                      track-by="user_id"
                      placeholder="Select Other POS locations"
                      @select="onSelectLocations($event)"
                      :multiple="true"
                    ></multiselect>
                  </div>
                  <!-- <Tooltip :title="'OTHER USER LOCATION FOR POS'" /> -->
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-3 mb-4">
                <div class="d-flex align-items-center">
                  <b-form-checkbox
                    v-model="userDetails.TFA"
                    unchecked-value="N"
                    value="Y"
                    name="tfa-checkbox"
                    class="j-checkbox mb-0"
                    @change="onChange2FA($event)"
                  />
                  <label class="mb-0">2FA</label>
                </div>
              </div>

              <div class="col-lg-6 col-xl-3 mb-4">
                <div class="d-flex align-items-center">
                  <b-form-checkbox
                    v-model="userDetails.use_only_authenticator"
                    unchecked-value="N"
                    value="Y"
                    name="authenticator-checkbox"
                    class="j-checkbox mb-0"
                    @change="onChangeUseOnlyAuthenticator($event)"
                  />
                  <label class="mb-0 mr-3">Use Only Authenticator</label>
                </div>
              </div>

              <div
                class="col-lg-6 col-xl-3 align-self-center mb-3"
                v-if="[13].includes(userDetails.role_id)"
              >
                <div class="d-flex align-items-center" style="gap: 20px">
                  <div class="d-flex align-items-center">
                    <b-form-checkbox
                      v-model="userDetails.is_premier_kitchen_user"
                      unchecked-value="N"
                      value="Y"
                      name="check-button"
                      class="j-checkbox mb-0"
                    />
                    <label class="mb-0">Premier Kitchen User</label>
                  </div>
                </div>
                <p class="error_message"></p>
              </div>

              <div
                v-if="!(this.affectedUserId == this.editorUser)"
                class="col-lg-6 col-xl-3 align-self-center mb-3"
              >
                <div class="d-flex align-items-center">
                  <label class="mb-0 mr-3">{{ $t("active") }}</label>
                  <b-form-checkbox
                    v-model="userDetails.is_active"
                    name="active-checkbox"
                    class="j-checkbox mb-0 ml-2"
                  />
                </div>

                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <div
                class="col-md-12 col-xl-12 text-center mt-4"
                v-if="
                  (QRcode && QRcode.length > 0) ||
                  userDetails.use_only_authenticator === 'Y'
                "
              >
                <div class="row">
                  <div
                    class="col-md-6 text-left"
                    v-if="userDetails.use_only_authenticator === 'Y'"
                  >
                    <h6>Please Scan This QRCode on you Authenticator App</h6>
                    <img :src="userDetails.authenticatorQRCode" alt />
                  </div>

                  <div
                    class="col-md-6 text-left"
                    v-if="QRcode && QRcode.length > 0"
                  >
                    <img :src="QRcode" alt />
                  </div>
                </div>
              </div>
            </div>
          </b-collapse>
        </section>
        <div class="col-lg-12 col-xl-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="updateUser(true)"
            class="btn-blue"
          >
            {{ $t("update") }}
          </button>
          <!-- <button @click.prevent.stop="onResetForm" class="btn-black">{{ $t('reset') }}</button> -->
          <b-button class="btn-outline-grey" variant="default" to="users">{{
            $t("cancel")
          }}</b-button>
          <button
            @click.prevent.stop="
              () => {
                if (userDetails.use_only_authenticator === 'Y') {
                  $toasted.show(
                    'You have choosen to use only Authenticator App'
                  );
                  return;
                }
                $bvModal.show('editPassword');
              }
            "
            class="btn-black"
          >
            {{ $t("reset") }} {{ $t("passwordpin") }}
          </button>
          <b-button
            v-if="userDetails.TFA == 'Y'"
            class="btn-outline-grey"
            variant="default"
            @click.prevent.stop="GetQRCode(null)"
            >2FA {{ $t("authentication") }}</b-button
          >
        </div>
      </form>
    </div>

    <b-modal id="tfashow" hide-footer hide-header no-close-on-backdrop>
      <button
        class="btn-modal-close"
        style="top: 15px; right: 15px; position: absolute; z-index: 99"
        @click="ClearData()"
      >
        &times;
      </button>
      <label class="h4 mt-2 mb-4 text-center"
        >Your old 2FA Code will be disabled...Are you sure you want to create
        new QR Code ?</label
      >
      <br />
      <div class="text-center">
        <button class="btn-blue" @click.prevent.stop="GetQRCode('Yes')">
          Yes
        </button>
        <button class="btn-blue text-right" @click.prevent.stop="ClearData()">
          No
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import UserService from "@/services/UserService";
import { error } from "util";
import { decryptString, encryptString } from "@/helper/collection";

const selected = {
  Country: "",
  Gender: "",
  Cinemas: "",
  Role: "",
  State: "",
  City: "",
  Designation: "",
  Departments: "",
  Distributor: "",
};

export default {
  data() {
    return {
      selectedUserLocations: [],
      USERSLOCATIONS: [],
      CinemasCopy: [],
      searchCinema: "",
      RolesCopy: [],
      searchRole: "",
      btenable: false,
      employeementType: ["Contract", "Permanent", "Probation"],
      loginRoleId: null,
      editorUser: null,
      affectedUserId: null,
      roleIdUser: null,
      isRoleID: true,
      messagegender: "Please Select Gender.",
      messagecountry: "Please Select Country.",
      messagestate: "Please Select State.",
      messagecity: "Please Select City.",
      messagerole: "Please Select Role.",
      messagedesignation: "Please Select Designation.",
      messagecinema: "Please Select Cinema.",
      messagedepartment: "Please Select Department.",
      messagedistributor: "Please Select Distributor.",
      storeList: [],
      submitted: false,
      userDetails: {
        username: "",
        first_name: "",
        pos_location_access: "",
        pos_access: "Y",
        fnb_access: "Y",
        order_pickup_access_only: "N",
        is_premier_kitchen_user: "N",
        middle_name: "",
        last_name: "",
        email_id: "",
        mobile_no: "",
        cinema_id: "",
        role_id: "",
        password: "",
        zipcode: "",
        userpin: "",
        passwordpin: "",
        store_id: null,
        selectedStore: "",
        //userprofileData
        up_employee_code: "",
        up_dob: new Date("1990-01-01"),
        up_doj: "",
        up_address1: "",
        up_alt_contact_no: "",
        // dropdown ids
        designation_id: null,
        gender_id: null,
        city_id: null,
        state_id: null,
        country_id: null,
        department_id: null,
        user_profile_image_url: "",
        is_active: false,
        up_employment_type: "",
        TFA: "N",
        country_mob_code: "",
        use_only_authenticator: "N",
        authenticator_secret: "",
        authenticatorQRCode: null,
        city_name: "",
      },

      showAuthenticatorQRCode: false,

      selected: selected,
      flag: {
        isDistributor: false,
      },

      Distributors: [],

      //
      Genres: [],
      GenresMethod: {
        GET: "/admin/",
        tableName: "ms_genre",
        urlKey: "genres",
      },

      Gender: [],
      GenderMethod: {
        GET: "/admin/",
        tableName: "ms_gender",
        urlKey: "gender",
      },

      Countries: [],
      CountriesMethod: {
        GET: "/admin/",
        tableName: "ms_countries",
        urlKey: "countries",
      },

      States: [],
      StatesMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_states",
        urlKey: "states",
      },

      Cities: [],
      CitiesMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_cities",
        urlKey: "cities",
      },

      Roles: [],
      RolesMethod: {
        GET: "/admin/",
        tableName: "ms_roles",
        urlKey: "roles",
      },

      Designations: [],
      DesignationsMethods: {
        GET: "/admin/",
        tableName: "ms_designations",
        urlKey: "designations",
      },

      Cinemas: [],
      CinemasMethods: {
        GET: "/admin/",
        tableName: "ms_cinemas",
        urlKey: "cinemas",
      },
      Departments: [],
      DepartmentsMethods: {
        GET: "/admin/",
        tableName: "ms_departments",
        urlKey: "departments",
      },
      user_id: "",
      errmsg: "",
      futuredate: "",
      previousdate: "",
      searchCountry: "",
      CountriesCopy: [],
      searchState: "",
      StatesCopy: [],
      searchCity: "",
      CitiesCopy: [],
      //
      showcurrentpassword: true,
      shownewpassword: false,
      submitted1: false,
      submitted2: false,
      userid: "",
      password: "",
      passwordpin: "",
      cpassword: "",
      QRcode: "",
      searchCode: "",
      CodeListCopy: [],
      countryList: [],
      SelectedCountryCode: "",
      sectionCollapse: {
        personalDetailsForm: true,
        loginDetails: true,
      },
    };
  },
  computed: {
    activeCinemas() {
      return this.Cinemas.filter((cinema) => cinema.cine_is_active);
    },
    personalDetailsForm() {
      return this.personaldetails.filter(
        (personal) => personal.user_type === 1
      );
    },
    loginDetails() {
      return this.logindetails.filter((login) => login.login_type === 1);
    },
  },
  beforeMount() {
    const { role_id } = this.secureStore.get("USINFO");
    const { key } = this.$route.query;
    let queryParams = this.$route.query;
    if(key) {
      let tempKey = decryptString(key);
      try {
         queryParams = tempKey ? JSON.parse(tempKey) : this.$route.query
      } catch (err) {
        console.log('Error:', err);
      }
    }

    if (role_id) {
      const { user_id } = queryParams;
      console.log("user_id :", user_id);
      this.user_id = user_id;

      this.loginRoleId = role_id;
      this.editorUser = this.secureStore.get("USINFO").user_id;
      console.log(this.secureStore.get("USINFO"), "USERRRR");

      // this.editorUser = user_id;
      // console.log(
      //   'window.location.hash.includes("/edit-user?user_id=" + user_id) :',
      //   window.location.hash.includes("/edit-user?user_id=" + user_id)
      // );
      if (user_id == this.editorUser) {
        this.$router.push({
          path: "/access-denied",
        });
      }
      let roleid = this.secureStore.get("USINFO").role_id;
      if (true) {
        this.isRoleID = false;
      }
      /////////////////////////////////////////////////////
      this.futuredate = new Date();
      this.futuredate.setDate(this.futuredate.getDate() + 7);
      this.previousdate = new Date();
      this.previousdate.setFullYear(this.previousdate.getFullYear() - 50);
      // console.log("previousdate :", previousdate);
    } else {
      this.$router.push({ path: "/access-denied" });
    }

    const { user_id } = queryParams;
    this.roleIdUser = role_id;
    if (user_id) {
      this.affectedUserId = user_id;
      this.getUserDetailsList(user_id);
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    getStoreManagement(cinema_id, sm_id = null) {
      this.storeList = [];
      this.userDetails["selectedStore"] = "";
      this.userDetails["store_id"] = null;
      MasterService.GetStoreManagement({
        cine_id: cinema_id,
      })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.storeList = data.Records;
            if (sm_id) {
              let filterStore = data.Records.find((x) => x.sm_id == sm_id);
              if (filterStore) {
                this.userDetails["selectedStore"] = filterStore;
                this.userDetails["store_id"] = filterStore["sm_id"];
              }
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        });
    },
    getUsersList: function (pos_location_access_array = []) {
      MasterService.GetUsers({ roles: [4, 8] })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            // this.USERSLOCATIONS = data.Records;
            this.USERSLOCATIONS = data.Records.filter((x) => {
              return (
                (x.role_id == 4 || x.role_id == 8) &&
                x.user_id != this.affectedUserId
              );
            });

            if (pos_location_access_array.length > 0) {
              this.selectedUserLocations = this.USERSLOCATIONS.filter((x) =>
                pos_location_access_array.includes(String(x.user_id))
              );
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    setUserLocationLabel(e) {
      return `${e.first_name} ${e.last_name ? e.last_name : ""} ${
        e.cine_name ? "(" + e.cine_name + ")" : ""
      }`;
    },
    onSelectLocations(location) {
      console.log("onSelect USER location", location);
    },
    onSearchCode() {
      if (this.searchCode && this.searchCode.length > 0) {
        this.countryList = this.CodeListCopy.filter((x) => {
          if (
            x.country_mob_code &&
            x.country_mob_code
              .toLowerCase()
              .includes(this.searchCode.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.countryList = this.CodeListCopy;
      }
    },
    ClearData: function () {
      this.$bvModal.hide("tfashow");
    },
    GetQRCode: function (flag) {
      if (
        this.userDetails.tfa_secret_code == null ||
        (this.userDetails.tfa_secret_code.length > 0 && flag == "Yes")
      ) {
        this.$bvModal.hide("tfashow");

        let loader = this.$loading.show();

        let payload = {
          user_id: this.user_id,
        };

        UserService.GenerateQrCode(payload)
          .then((response) => {
            const { data } = response;

            if (data.status && data.url && data.url.length > 0) {
              this.QRcode = data.url;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      } else {
        this.$bvModal.show("tfashow");
      }
    },
    onSearchCinema: function () {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    onSearchRoles: function () {
      if (this.searchRole && this.searchRole.length > 0) {
        this.Roles = this.RolesCopy.filter((x) => {
          if (
            x.role_name.toLowerCase().includes(this.searchRole.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Roles = this.RolesCopy;
      }
    },
    onSearchCountry: function (value) {
      if (this.searchCountry && this.searchCountry.length > 0) {
        this.Countries = this.CountriesCopy.filter((x) => {
          if (
            x.country_name
              .toLowerCase()
              .includes(this.searchCountry.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Countries = this.CountriesCopy;
      }
    },
    onSearchState: function (value) {
      if (this.searchState && this.searchState.length > 0) {
        this.States = this.StatesCopy.filter((x) => {
          if (
            x.state_name.toLowerCase().includes(this.searchState.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.States = this.StatesCopy;
      }
    },
    onSearchCity: function (value) {
      if (this.searchCity && this.searchCity.length > 0) {
        this.Cities = this.CitiesCopy.filter((x) => {
          if (
            x.city_name.toLowerCase().includes(this.searchCity.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cities = this.CitiesCopy;
      }
    },
    onSelectEmployeementTypeHandler: function (value) {
      // this.userDetails.employeementSelectedType = value;

      this.userDetails.up_employment_type = value;

      console.log(
        "this.userDetails.employeementSelectedType ",
        this.userDetails.up_employment_type
      );
    },
    clearSelectedDate: function () {
      this.userDetails.up_dob = "";
    },
    cleardoj: function () {
      this.userDetails.up_doj = "";
    },
    OnCloseModal() {
      this.$bvModal.hide("editPassword");
      this.shownewpassword = false;
      this.showcurrentpassword = true;
      this.passwordpin = "";
    },
    onResetForm: function () {
      this.userDetails = {
        username: "",
        first_name: "",
        middle_name: "",
        last_name: "",
        email_id: "",
        mobile_no: "",
        cinema_id: "",
        role_id: "",
        password: "",
        userpin: "",
        passwordpin: "",
        pos_location_access: "",
        pos_access: "Y",
        fnb_access: "Y",
        order_pickup_access_only: "N",
        //userprofileData
        up_employee_code: "",
        up_dob: "",
        up_doj: "",
        up_address1: "",
        up_alt_contact_no: "",
        store_id: null,
        selectedStore: "",
        // dropdown ids
        designation_id: null,
        gender_id: null,
        city_id: null,
        state_id: null,
        country_id: null,
        department_id: null,
        d_id: null,
        user_profile_image_url: "",
        up_employment_type: "",
        use_only_authenticator: "N",
        authenticator_secret: "",
      };
      this.selected = {
        ...selected,
      };
    },
    onSelectHandler: function (type, value) {
      if (type == "gender") {
        this.selected.Gender = value.gender;
        this.userDetails.gender_id = value.gender_id;
      } else if (type == "country") {
        this.selected.Country = value.country_name;
        this.userDetails.country_id = value.country_id;
        this.userDetails.country_mob_code = value.country_mob_code;
        this.getStatesList(value.country_id, null);
      } else if (type == "state") {
        this.selected.State = value.state_name;
        this.userDetails.state_id = value.state_id;
        this.getCitiesList(value.state_id, null);
      } else if (type == "city") {
        this.selected.City = value.city_name;
        this.userDetails.city_id = value.city_id;
      } else if (type == "role") {
        this.selected.Role = value.role_name;
        this.userDetails.role_id = value.role_id;
        value.role_name === "Distributor"
          ? (this.flag.isDistributor = true)
          : (this.flag.isDistributor = false);
        if (this.flag.isDistributor) {
          this.selected.Cinemas = "";
          //this.selected.Gender = "";
          this.userDetails.gender_id = "";
          this.selected.Designation = "";
          this.selected.Departments = "";
          this.selected.Distributor = "";
          this.userDetails.up_employment_type = "";
          this.userDetails.cinema_id = "";
        }
        this.searchRole = "";
        this.onSearchRoles();
      } else if (type == "designation") {
        this.selected.Designation = value.designation;
        this.userDetails.designation_id = value.designation_id;
      } else if (type == "cinema") {
        this.selected.Cinemas = value.cine_name;
        this.userDetails.cinema_id = value.cine_id;
        this.getStoreManagement(value.cine_id);
        this.searchCinema = "";
        this.onSearchCinema();
      } else if (type == "department") {
        this.selected.Departments = value.dept_name;
        this.userDetails.department_id = value.dept_id;
      } else if (type == "distributor") {
        this.userDetails.d_id = value.d_id;
        this.selected.Distributor = value.d_company_name;
      } else if (type == "countrycode") {
        this.userDetails.country_mob_code = value.country_mob_code;
        this.SelectedCountryCode = value.country_mob_code;
      } else if (type == "store") {
        this.userDetails["store_id"] = value.sm_id;
        this.userDetails["selectedStore"] = value;
      }
      this.$nextTick(() => {
        this.$validator.reset();
        this.$validator.errors.clear();
        this.$validator.resume();
        // console.log("object R :");
        this.$forceUpdate();
      });
    },
    removeHandler(type, event) {
      if (type == "store") {
        this.userDetails["store_id"] = null;
        this.userDetails["selectedStore"] = "";
      }
    },
    selectAllCinemas() {
      this.selected.Cinemas = "All";
      this.userDetails.cinema_id = null;
    },
    getUserDetailsList: function (user_id) {
      let pos_location_access_array = [];
      UserService.GetUserDetails({ user_id })
        .then((response) => {
          const { data } = response;
          console.log("data GetUserDetails s:", data);
          if (data.status && data.data) {
            this.userDetails = {
              ...this.userDetails,
              ...data.data,
            };
            let obj = data.data;
            pos_location_access_array = obj.pos_location_access
              ? obj.pos_location_access.split(",")
              : [];
            console.log("this.userDetails :>> ", this.userDetails);
            //  console.log('this.userDetails.up_employment_type', this.userDetails.up_employment_type);
            //  this.employeementType.map(x => {
            //    if(x == this.this.userDetails.up_employment_type){}

            //  });

            if (this.userDetails.is_active == "Y") {
              this.userDetails.is_active = true;
            } else {
              this.userDetails.is_active = false;
            }
            console.log(
              "set value get list user details  ",
              this.userDetails.is_active
            );
            // console.log('before mount ',this.userDetails.is_active == 'Y' ? true:false );
            // console.log('before edit active ',this.userDetails.is_active);
            //  this.userDetails.is_active = this.userDetails.is_active === true ? true : false;
            // console.log('After  edit .is_active=== ',this.userDetails.is_active);

            if (this.userDetails.authenticatorQRCode) {
              this.showAuthenticatorQRCode = true;
            }

            this.userDetails.up_dob =
              obj.up_dob && isValidDate(new Date(obj.up_dob))
                ? new Date(obj.up_dob)
                : "";

            this.userDetails.up_dob && this.userDetails.up_dob.length == 0
              ? (this.userDetails.up_dob = new Date("1990-01-01"))
              : this.userDetails.up_dob;

            this.userDetails.up_doj =
              obj.up_doj && isValidDate(new Date(obj.up_doj))
                ? new Date(obj.up_doj)
                : "";
            this.getDistributorsList(obj.distributor_id || null);
            this.getGenderList(obj.gender_id || null);
            this.getCountriesList(obj.country_id || null);
            this.getStatesList(obj.country_id || null, obj.state_id || null);
            this.getCitiesList(obj.state_id || null, obj.city_id || null);
            this.getRolesList(obj.role_id || null);
            this.getDesignationList(obj.designation_id || null);
            this.getCinemasList(obj.cine_id || obj.cinema_id || null);
            this.getDepartmentsList(obj.dept_id || obj.department_id || null);
            this.getStoreManagement(
              obj.cine_id || obj.cinema_id || null,
              obj.store_id || null
            );

            function isValidDate(d) {
              if (Object.prototype.toString.call(d) === "[object Date]") {
                // it is a date
                if (isNaN(d.getTime())) {
                  return false;
                  // d.valueOf() could also work
                  // date is not valid
                } else {
                  return true;
                  // date is valid
                }
              } else {
                return false;
                // not a date
              }
            }
          } else data.message ? this.$toasted.show(data.message) : "";
        })
        .catch(this._CatchError)
        .finally(() => {
          this.getUsersList(pos_location_access_array);
        });
    },
    getDistributorsList: function (d_id) {
      let payload = {
        tableName: "ms_distributors",
        d_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Distributors = data.Records;
              if (d_id) {
                this.Distributors.map((x) => {
                  if (d_id === x.d_id) {
                    this.selected.Distributor = x.d_company_name;
                  }
                });
              }
            }
          } else data.message ? this.$toasted.show(data.message) : "";
        })
        .catch(this._CatchError);
    },
    getCinemasList: function (cine_id) {
      this.Cinemas = [];
      let body = this.getRequestBody("GET", undefined, this.CinemasMethods);
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Cinemas = data.Records;
              this.CinemasCopy = data.Records;

              if (cine_id) {
                this.Cinemas.map((x) => {
                  if (cine_id === x.cine_id) {
                    this.selected.Cinemas = x.cine_name;
                    this.userDetails.cinema_id = x.cine_id;
                  }
                });
              }
            }
          } else data.message ? this.$toasted.show(data.message) : "";
        })
        .catch(this._CatchError);
    },
    getDepartmentsList: function (dept_id) {
      this.Departments = [];
      let body = this.getRequestBody("GET", undefined, this.DepartmentsMethods);
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Departments = data.Records;
              if (dept_id) {
                this.Departments.map((x) => {
                  if (dept_id === x.dept_id) {
                    this.selected.Departments = x.dept_name;
                  }
                });
              }
            }
          } else data.message ? this.$toasted.show(data.message) : "";
        })
        .catch(this._CatchError);
    },
    getRolesList: function (role_id) {
      this.Roles = [];
      let body = this.getRequestBody("GET", undefined, this.RolesMethod);
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Roles = data.Records;
              this.RolesCopy = data.Records;
              // this.getUserDetails(user_id);
              if (role_id) {
                this.Roles.map((x) => {
                  if (x.role_id === role_id) {
                    console.log("role_id :", role_id);
                    this.selected.Role = x.role_name;
                    this.flag.isDistributor = x.role_name === "Distributor";
                  }
                });
              }
            }
          } else data.message ? this.$toasted.show(data.message) : "";
        })
        .catch(this._CatchError);
    },

    getGenderList: function (gender_id) {
      this.Gender = [];
      let body = this.getRequestBody("GET", undefined, this.GenderMethod);
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Gender = data.Records;
              if (gender_id) {
                this.Gender.map((x) => {
                  if (x.gender_id === gender_id) {
                    this.selected.Gender = x.gender;
                    this.userDetails.gender_id = x.gender_id;
                  }
                });
              }
            }
          } else data.message ? this.$toasted.show(data.message) : "";
        })
        .catch(this._CatchError);
    },
    getCountriesList: function (country_id) {
      this.Countries = [];
      let body = this.getRequestBody("GET", undefined, this.CountriesMethod);
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Countries = data.Records;
              this.CountriesCopy = data.Records;
              this.CodeListCopy = data.Records;
              this.countryList = data.Records;
              if (country_id) {
                this.Countries.map((x) => {
                  if (country_id === x.country_id) {
                    this.selected.Country = x.country_name;
                  }
                });
              }
            }
          } else data.message ? this.$toasted.show(data.message) : "";
        })
        .catch(this._CatchError);
    },
    getStatesList: function (country_id, state_id) {
      this.States = [];
      let body = this.getRequestBody("GET", undefined, {
        ...this.StatesMethod,
        params: { id: "country_id-" + country_id },
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.States = data.Records;
              this.StatesCopy = data.Records;
              if (state_id) {
                this.States.map((x) => {
                  if (state_id === x.state_id) {
                    this.selected.State = x.state_name;
                  }
                });
              }
            }
          } else data.message ? this.$toasted.show(data.message) : "";
        })
        .catch(this._CatchError);
    },
    getCitiesList: function (state_id, city_id) {
      this.Cities = [];
      let body = this.getRequestBody("GET", undefined, {
        ...this.CitiesMethod,
        params: { id: "state_id-" + state_id },
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Cities = data.Records;
              this.CitiesCopy = data.Records;
              if (city_id) {
                this.Cities.map((x) => {
                  if (city_id === x.city_id) {
                    this.selected.City = x.city_name;
                  }
                });
              }
            }
          } else data.message ? this.$toasted.show(data.message) : "";
        })
        .catch(this._CatchError);
    },
    getDesignationList: function (designation_id) {
      this.Designations = [];
      let body = this.getRequestBody(
        "GET",
        undefined,
        this.DesignationsMethods
      );
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Designations = data.Records;
              if (designation_id) {
                this.Designations.map((x) => {
                  if (designation_id === x.designation_id) {
                    this.selected.Designation = x.designation;
                  }
                });
              }
            }
          } else data.message ? this.$toasted.show(data.message) : "";
        })
        .catch(this._CatchError);
    },

    updateUser: function (flag) {
      console.log("update User functionss ");
      // console.log(" update () this.userDetails :", this.userDetails);
      // console.log("update () not final active ", this.userDetails.is_active);

      // if( this.userDetails.is_active == true){
      //   this.userDetails.is_active = 'Y'
      // }
      // else{
      //    this.userDetails.is_active = 'N'
      // }
      // console.log("final y or n active", this.userDetails.is_active);
      // this.userDetails.is_active = this.userDetails.is_active == true ? "Y" : "N";
      // console.log("before send ",this.userDetails.is_active);

      this.submitted = true;
      this.userDetails["pos_location_access"] = this.selectedUserLocations
        .map((x) => x.user_id)
        .toString();

      this.$validator.validate().then((valid) => {
        console.log("ontop", valid);
        valid = true;
        if (valid) {
          console.log("wwwwwwwwwwwww");
          if (!this.userDetails.country_mob_code) {
            console.log("1st If");
            return;
          }
          if (
            this.selected.Distributor &&
            this.selected.Distributor.length == 0 &&
            this.userDetails.role_id == 9
          ) {
            /* if(role)bcoz edit was not working */
            console.log("2nd If");
            console.log("update User functionss 3");
            this.$toasted.show(this.messagedistributor);

            return this.messagedistributor;
          } else {
            console.log("coming 1 :>> ");
            this.userDetails.role_id == 9
              ? (this.userDetails.up_dob = "")
              : this.userDetails.up_dob;
            this.userDetails.role_id == 9
              ? (this.userDetails.up_doj = "")
              : this.userDetails.up_doj;
            if (
              false
              // this.userDetails.role_id != 9 &&
              // (!this.userDetails["gender_id"] ||
              //   String(this.userDetails.gender_id).length === 0)
            ) {
              console.log("coming 2 :>> ");

              this.$toasted.show("Please Select Gender");
            } else if (
              false
              // this.userDetails.role_id != 9 &&
              // (!this.userDetails["up_employment_type"] ||
              //   String(this.userDetails.up_employment_type).length === 0)
            ) {
              console.log("coming 3 :>> ");

              this.$toasted.show("Please Select Employement Type");
            } else if (
              !this.userDetails["role_id"] ||
              String(this.userDetails.role_id).length === 0
            ) {
              console.log("coming 4 :>> ");

              this.$toasted.show("Please Select Role ");
            } else if (
              (this.userDetails.role_id == 3 ||
                this.userDetails.role_id == 4 ||
                this.userDetails.role_id == 8 ||
                this.userDetails.role_id == 7) &&
              (!this.userDetails["cinema_id"] ||
                String(this.userDetails.cinema_id).length === 0)
            ) {
              console.log("coming 5 :>> ");

              this.$toasted.show("Please Select Cinema ");
            } else if (this.userDetails.password.length > 0) {
              console.log("coming 6 :>> ");
              let regex =
                /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,16}$/;
              let re = this.userDetails.password.match(regex);
              console.log("re :", re);
              if (!re && this.userDetails.use_only_authenticator === "N") {
                console.log("coming 7 :>> ");
                this.errmsg =
                  "Password must contain minimum 8 and maximum 16 characters, Contains at least one Lowercase letter, one Uppercase letter and one Special Character.";
              } else {
                console.log("coming 8 :>> ");
                this.userDetails.password = re[0];
                console.log(
                  "this.userDetails.password :",
                  this.userDetails.password
                );
                if (flag) {
                  this.btenable = true;
                  console.log("before send");
                  UserService.UpdateAUser({
                    ...this.userDetails,
                    flag: this.flag,
                  })
                    .then((result) => {
                      this.btenable = false;

                      const { data } = result;
                      if (data.status) {
                        this.$router.go(-1);
                        // this.userDetails = data.data;
                      } else
                        data.message ? this.$toasted.show(data.message) : "";
                    })
                    .catch(this._CatchError);
                }
              }
            } else if (
              ["4", "8"].includes(String(this.userDetails["role_id"])) &&
              !this.userDetails["store_id"]
            ) {
              return this.$toasted.show("Please Select Store Management");
            } else {
              if (flag) {
                console.log(
                  "this.userDetails.userpin :>> ",
                  this.userDetails.userpin
                );
                console.log("this.flag :>> ", this.flag);
                console.log("before send");
                UserService.UpdateAUser({
                  ...this.userDetails,
                  flag: this.flag,
                })
                  .then((result) => {
                    this.btenable = false;
                    const { data } = result;
                    if (data.status) {
                      this.$router.go(-1);
                      // this.userDetails = data.data;
                    } else data.message ? this.$toasted.show(data.message) : "";
                  })
                  .catch(this._CatchError);
              }
            }
          }
        }
      });
    },
    uploadImage: function (image) {
      let loader = this.$loading.show();

      let self = this;
      let formData = new FormData();
      formData.append("image", image.target.files[0]);
      formData.append("imagePath", "User Image");
      MasterService.GlobalUploadImage(formData)
        .then((response) => {
          const { data } = response;
          data.message ? this.$toasted.show(data.message) : "";
          if (data.status) {
            self.userDetails.user_profile_image_url = data.path;
          }
          self.BaseURL = data.BaseURL;
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },
    ProceedtoNewPassword() {
      this.submitted1 = true;
      this.$validator.validateAll("form1").then((valid) => {
        console.log("valid :>> ", valid);
        if (valid) {
          let payload = {
            userid: this.editorUser,
            userpassword: this.password,
          };
          UserService.VerifyCurrentPassword(payload)
            .then((response) => {
              const { data } = response;
              if (data.status) {
                this.$toasted.show(data.message);
                this.showcurrentpassword = false;
                this.shownewpassword = true;
              } else {
                this.$toasted.show(
                  data.message ||
                    "Sorry! Something went wrong. kindly contact your administrator"
                );
              }
            })
            .catch(this._CatchError);
        } else {
          console.log("else");
        }
      });
    },
    onFinalProceed() {
      this.submitted2 = true;
      this.$validator.validateAll("form2").then((valid) => {
        if (valid) {
          let payload = {
            userid: this.user_id,
            password: this.passwordpin,
          };
          UserService.UpdatePasswordPin(payload).then((response) => {
            const { data } = response;
            if (data.status) {
              this.$toasted.show(data.message);
              this.$bvModal.hide("editPassword");
              this.passwordpin = "";
              this.cpassword = "";
              this.password = "";
              this.showcurrentpassword = true;
              this.shownewpassword = false;
            } else {
              this.$toasted.show(
                data.message ||
                  "Sorry! Something went wrong. kindly contact your administrator"
              );
            }
          });
        }
      });
    },
    onChange2FA: function () {
      if (this.userDetails.TFA === "Y") {
        this.userDetails.use_only_authenticator = "N";
        this.onChangeUseOnlyAuthenticator();
      }
    },
    onChangeUseOnlyAuthenticator: function () {
      // this.userDetails.use_only_authenticator
      if (this.userDetails.use_only_authenticator === "Y") {
        this.userDetails.TFA = "N";
        this.fetchAuthenticatorCode();
      } else {
        this.showAuthenticatorQRCode = false;
        this.userDetails.authenticatorQRCode = null;
        this.userDetails.authenticator_secret = "";
      }
    },
    fetchAuthenticatorCode() {
      UserService.GetAuthenticatorCode()
        .then(({ data }) => {
          if (data.status) {
            this.userDetails.authenticator_secret = data.data.base32;
            this.userDetails.authenticatorQRCode = data.dataURL;
            this.showAuthenticatorQRCode = true;
          }
        })
        .catch((err) => {
          console.log("Error when fetching the qrcode data", err);
        });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/UserManagement/UsersComponents/editUserNew.vue